/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPDISINVESTMENTTYPE } from './IAPDISINVESTMENTTYPE';
import {
    IAPDISINVESTMENTTYPEFromJSON,
    IAPDISINVESTMENTTYPEFromJSONTyped,
    IAPDISINVESTMENTTYPEToJSON,
} from './IAPDISINVESTMENTTYPE';
import type { ProposalSummaryJustIncomePortfolioAssetSplit } from './ProposalSummaryJustIncomePortfolioAssetSplit';
import {
    ProposalSummaryJustIncomePortfolioAssetSplitFromJSON,
    ProposalSummaryJustIncomePortfolioAssetSplitFromJSONTyped,
    ProposalSummaryJustIncomePortfolioAssetSplitToJSON,
} from './ProposalSummaryJustIncomePortfolioAssetSplit';

/**
 * 
 * @export
 * @interface ProposalSummaryJustIncomePortfolio
 */
export interface ProposalSummaryJustIncomePortfolio {
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryJustIncomePortfolio
     */
    assetCode?: number;
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryJustIncomePortfolio
     */
    fundName?: string;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryJustIncomePortfolio
     */
    incomeAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryJustIncomePortfolio
     */
    cashAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryJustIncomePortfolio
     */
    unitTransferAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryJustIncomePortfolio
     */
    totalAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryJustIncomePortfolio
     */
    onceOffPercentage?: number;
    /**
     * 
     * @type {IAPDISINVESTMENTTYPE}
     * @memberof ProposalSummaryJustIncomePortfolio
     */
    feeDisinvestmentTypeId?: IAPDISINVESTMENTTYPE;
    /**
     * 
     * @type {Array<ProposalSummaryJustIncomePortfolioAssetSplit>}
     * @memberof ProposalSummaryJustIncomePortfolio
     */
    proposalSummaryJustIncomePortfolioAssetSplit?: Array<ProposalSummaryJustIncomePortfolioAssetSplit>;
}

/**
 * Check if a given object implements the ProposalSummaryJustIncomePortfolio interface.
 */
export function instanceOfProposalSummaryJustIncomePortfolio(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProposalSummaryJustIncomePortfolioFromJSON(json: any): ProposalSummaryJustIncomePortfolio {
    return ProposalSummaryJustIncomePortfolioFromJSONTyped(json, false);
}

export function ProposalSummaryJustIncomePortfolioFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryJustIncomePortfolio {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assetCode': !exists(json, 'AssetCode') ? undefined : json['AssetCode'],
        'fundName': !exists(json, 'FundName') ? undefined : json['FundName'],
        'incomeAmount': !exists(json, 'IncomeAmount') ? undefined : json['IncomeAmount'],
        'cashAmount': !exists(json, 'CashAmount') ? undefined : json['CashAmount'],
        'unitTransferAmount': !exists(json, 'UnitTransferAmount') ? undefined : json['UnitTransferAmount'],
        'totalAmount': !exists(json, 'TotalAmount') ? undefined : json['TotalAmount'],
        'onceOffPercentage': !exists(json, 'OnceOffPercentage') ? undefined : json['OnceOffPercentage'],
        'feeDisinvestmentTypeId': !exists(json, 'FeeDisinvestmentTypeId') ? undefined : IAPDISINVESTMENTTYPEFromJSON(json['FeeDisinvestmentTypeId']),
        'proposalSummaryJustIncomePortfolioAssetSplit': !exists(json, 'ProposalSummaryJustIncomePortfolioAssetSplit') ? undefined : ((json['ProposalSummaryJustIncomePortfolioAssetSplit'] as Array<any>).map(ProposalSummaryJustIncomePortfolioAssetSplitFromJSON)),
    };
}

export function ProposalSummaryJustIncomePortfolioToJSON(value?: ProposalSummaryJustIncomePortfolio | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AssetCode': value.assetCode,
        'FundName': value.fundName,
        'IncomeAmount': value.incomeAmount,
        'CashAmount': value.cashAmount,
        'UnitTransferAmount': value.unitTransferAmount,
        'TotalAmount': value.totalAmount,
        'OnceOffPercentage': value.onceOffPercentage,
        'FeeDisinvestmentTypeId': IAPDISINVESTMENTTYPEToJSON(value.feeDisinvestmentTypeId),
        'ProposalSummaryJustIncomePortfolioAssetSplit': value.proposalSummaryJustIncomePortfolioAssetSplit === undefined ? undefined : ((value.proposalSummaryJustIncomePortfolioAssetSplit as Array<any>).map(ProposalSummaryJustIncomePortfolioAssetSplitToJSON)),
    };
}

